module.exports = __webpack_public_path__ + "assets/Github.34119f98.svg";